<template>
    <div class="conversation" >
        <Loader v-if = "lastMessage && lastMessage.loading" style="height: 100%"/>
        <div v-else>
            <div v-if="lastMessage && lastMessage.message">
                <div data-name="conversation-body" :class="{'current-user': isCurrentUser}">
                    <div data-name="camp-pic">
                        <img v-lazy="lastMessage.campPic" alt="">
                    </div>
                    <div data-name="message" class="flex-grow-1">
                        <div>
                            <p style="word-break: break-word"> {{lastMessage.message}} </p>
                        </div>
                    </div>
                </div>
                <div data-name="reply">
                    <Button 
                        @click.native="toChat(isCurrentUser ? 'Open in messages' : 'Reply')" 
                        type="linkButton"
                        :class="{'open-in-mesages-dashboard': isCurrentUser, 'reply-dashboard': !isCurrentUser}"
                        style="margin-top: 12px; text-align: right;">
                            <span>{{isCurrentUser ? 'Open in mesages' : 'Reply'}}</span>
                            <Icon icon="dashboard-reply-icon"/>
                    </Button>
                </div>
            </div>
            <div class="empty-conversation" v-else>
                <Icon icon='dashboard-empty-conversation'/>
                <Button 
                    @click.native="toChat('Send message')" 
                    type="linkButton"
                    class="send-message-dashboard">
                    Send Message
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import Button from '../../../Button'
import {truncate} from '../../../../../../core/filters'
import {useUserId, useRouter} from '../../../../../../core/hooks'
import {computed} from '@vue/composition-api'
import Loader from '../../../../../../components/Icons/Loader.vue'
export default {
    name: 'Conversation',
    components: {
        Icon,
        Button,
        Loader
    },
    props: {
        request: Object
    },
    filters: {
        truncate
    },
    setup(props, context){
        const {userId} = useUserId()
        const {router, route} = useRouter()
        const lastMessage = computed(() => props.request.messageData)
        const isCurrentUser = computed(() => props.request.messageData && props.request.messageData.uid === userId)
        const toChat = (openedFrom) => {
            context.root.$ga.event('Chat', 'Chatroom Opened', 'OpenedFrom', `Dashboard ${openedFrom}`)
            context.root.$sendMixpanelEvent('Chatroom Opened', {
                'Opened From': `Dashboard ${openedFrom}`
            })

            router.push({
                name: 'chat',
                query: {
                    campaigns: [props.request.sender.campaign, props.request.receiver.campaign],
                    newChat: true
                }
            }).catch(() => {})
        }

        return {
            lastMessage,
            toChat,
            isCurrentUser
        } 
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/variables.scss';
div.conversation {
    width: 100%;
    // width: 448px;
    height: 134px;
    background: $c14;
    box-shadow: 0px 1px 2px rgba(8, 35, 48, 0.02), 0px 2px 12px rgba(8, 35, 48, 0.08), 0px -1px 2px rgba(8, 35, 48, 0.02);
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;

    div[data-name="conversation-body"] {
        display: flex;
        justify-content: space-between;
        div[data-name="camp-pic"] {
            width: 24px;
            img {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                object-fit: fill;
            }
        }
        
        div[data-name="message"] {
            width: 50%;
            // width: 376px;
            height: 76px;
            background: #E3E5FD;
            border-radius: 8px;
            position: relative;
            margin-left: 24px;
            padding-left: 16px;
            padding-right: 16px;
            padding-top: 8px;
            padding-bottom: 8px;
            
            div {
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                p {
                    color: $c6;
                    font-size: $p5;
                    &.ellipsed {
                        text-overflow: ellipsis !important;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }
            &::before {
                content: "";
                position: absolute;
                border-top: 0px solid transparent;
                border-right: 28px solid #E3E5FD;
                border-bottom: 21px solid transparent;
                right: 100%;
                top: 0;
                transform: translate(15px, 0);
            }
        }
        &.current-user {
            div[data-name="message"] {
                margin-left: 0;
                order: 1;
                background: $c10;
                &::before {
                    border-top: 0px solid transparent;
                    border-right: none;
                    border-left: 28px solid $c10;
                    right: 0;
                    transform: translate(15px, 0);
                }
            }
            div[data-name="camp-pic"] {
                width: 24px;
                order: 2;
                margin-left: 24px;
            }

            &+div {
                p[data-name="reply"] {
                    span {
                        color: $c3;
                    }
                    img {
                        filter: grayscale(100%) opacity(0.5)
                    }
                }
            }
        }
    }
    div[data-name="reply"] {
        text-align: right;
        span {
            font-size: $p5;
            color: $c1;
            margin-right: 4px;
        }
    }
}

div.empty-conversation {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>